import {Editor, Extension} from '@tiptap/core'
import TipTapCoreLoader from "../internals/TipTapCoreLoader";
import {Mention} from "@tiptap/extension-mention";

interface TipTapCommentImport {
    Editor: typeof Editor
    StarterKit: [],
    Suggestion: any,
    Mention: typeof Mention,
}

export default class TipTapCommentLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<TipTapCommentImport>;

    private static instance: TipTapCommentImport;

    public static load(): Promise<TipTapCommentImport> {
        if (TipTapCommentLoader.status == 0) {
            TipTapCommentLoader.status = 1;


            TipTapCommentLoader.promise = Promise.all([

                import(/* webpackChunkName: "tiptap-comment-css" */ './style/tiptap-comment.css'),

                TipTapCoreLoader.load(),

                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-document'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-text'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-dropcursor'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-gapcursor'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-history'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-paragraph'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/suggestion'),
                import(/* webpackChunkName: "tiptap-comment" */ '@tiptap/extension-mention'),

            ]).then(v => {
                console.log("TIP TAP COMMENT LOADER", v);

                let core = v[1];

                let exp = {
                    Editor: core.Editor,
                    StarterKit: [
                        //document
                        v[2].default.configure(),
                        //text
                        v[3].default.configure(),
                        //dropcursor
                        v[4].default.configure(),
                        //gapcursor
                        v[5].default.configure(),
                        //history
                        v[6].default.configure(),
                        //paragraph
                        v[7].default.configure(),
                    ],
                    Suggestion: v[8].default,
                    Mention: v[9].default
                } as unknown as TipTapCommentImport;

                TipTapCommentLoader.instance = exp;
                TipTapCommentLoader.status = 2;

                return exp;

            });

            return TipTapCommentLoader.promise;
        } else if (TipTapCommentLoader.status == 1) {
            return TipTapCommentLoader.promise;
        } else {
            return Promise.resolve(TipTapCommentLoader.instance);
        }
    }

}